import { Form } from 'antd';
import { useTranslation } from 'react-i18next';

import { Input } from 'components';

import useValidation from 'hooks/forms/useValidation';

import { IOtpStepProps } from './OtpStep.types';

const OtpStep = ({ loading }: IOtpStepProps) => {
  const { t } = useTranslation();
  const rule = useValidation();

  return (
    <>
      <Form.Item name="otp" label={t('form.label.otp')} rules={rule.ga} validateFirst>
        <Input.Password autoFocus disabled={loading} />
      </Form.Item>
    </>
  );
};

export default OtpStep;
